/* screens/workspace/canvas/ABCCanvas.jsx — inline-канвас ABC-анализа (S6).
   Read-only: метрики приоритетов, таблица (Блюдо/ABC/FC%/Статус FC/Комментарий),
   блок «Недостаточно данных». Поля и семантика приоритетов совпадают с боевым адаптером
   `adaptAbc` и ReportDetail.AbcReport (отчёт — генерируемый артефакт; правка result отложена).
   ХЕНДОФФ → frontend/components/chat/ABCCanvas.jsx. */

import { Icon } from '../../../components/ui/Icon.jsx';
import { AbcAnalysisReport } from '../../../components/reports/AbcAnalysisReport.jsx';
import { RR } from '../../../lib/router.jsx';
import { fmt } from '../../../lib/format.js';
import { CanvasErrorState, CanvasMetrics, CanvasSection, CanvasSkeleton, CanvasViewForm, FcStatusTag, PriorityTag, useCanvasLoad } from './CanvasViewForm.jsx';

  const { useNavigate } = RR;

  function ABCCanvas({ spec, onClose, panel }) {
    const { kind, data, error, retry } = useCanvasLoad(spec);
    const navigate = useNavigate();

    const id = data ? data.id : spec.id;
    const openHref = `/reports/${id}`;
    const header = { eyebrow: 'ABC-анализ', icon: 'analytics', title: (data && data.title) || 'ABC-анализ', panel };

    if (kind === 'loading') return <CanvasViewForm {...header} onClose={onClose}><CanvasSkeleton note="LLM читает позиции…" /></CanvasViewForm>;
    if (kind === 'error') return <CanvasViewForm {...header} onClose={onClose}><CanvasErrorState error={error} message="Не удалось загрузить отчёт" notFoundMessage="Отчёт не найден или был удалён." onRetry={retry} /></CanvasViewForm>;
    if (kind === 'partial') return <CanvasViewForm {...header} onClose={onClose}><CanvasSkeleton note="Считаю приоритеты…" /></CanvasViewForm>;

    const r = data.result;

    // v2 (детерминированный пайплайн): единый рендерер с кликабельными
    // тегами приоритетов/FC — общий с детальной страницей (/reports/:id).
    if (r && r.v2) {
      const v2footer = (
        <div className="cv-foot-actions">
          <button type="button" className="btn btn--primary btn--sm" onClick={() => navigate(openHref)}><span className="btn__label">Открыть отчёт</span><Icon name="arrow-up-right" size={14} /></button>
        </div>
      );
      return (
        <CanvasViewForm {...header} onClose={onClose} openHref={openHref} openLabel="Открыть" footer={v2footer}>
          <AbcAnalysisReport r={r} compact />
        </CanvasViewForm>
      );
    }

    const m = r.metrics || {};
    const metrics = [
      { label: 'P1 · срочно', value: m.p1_count ?? '—', tone: 'bad' },
      { label: 'P2 · проблема', value: m.p2_count ?? '—', tone: 'warn' },
      { label: 'P3 · внимание', value: m.p3_count ?? '—' },
      { label: 'Потенциал', value: m.potential_count ?? '—', tone: 'info' },
    ];

    const body = (
      <>
        <CanvasMetrics items={metrics} />
        <CanvasSection title="Позиции по приоритету" hint="FC% ниже = лучше">
          <div className="cv-table-wrap">
            <table className="cv-table">
              <thead><tr><th>Блюдо</th><th>Приоритет</th><th className="num">FC%</th><th>Статус FC</th><th>Комментарий</th></tr></thead>
              <tbody>
                {(r.items || []).map((it, i) => (
                  <tr key={i}>
                    <td data-label="Блюдо"><span className="cv-strong">{it.dish_name}</span> <span className="cv-abc num">{it.abc_code}</span></td>
                    <td data-label="Приоритет"><PriorityTag priority={it.priority} /></td>
                    <td className="num derived-cell" data-label="FC%">{it.fc_pct != null ? fmt.percent(it.fc_pct, { digits: 1 }) : '—'}</td>
                    <td data-label="Статус FC"><FcStatusTag status={it.fc_status} /></td>
                    <td data-label="Комментарий" className="cv-comment"><span className="text-dim">{it.comment}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CanvasSection>
        {r.insufficient_data && r.insufficient_data.length > 0 && (
          <CanvasSection title="Недостаточно данных">
            <ul className="cv-note-list">
              {r.insufficient_data.map((x, i) => (<li key={i}><Icon name="alert-triangle" size={13} /><span className="cv-strong">{x.dish_name}</span> — <span className="text-mute">{x.reason}</span></li>))}
            </ul>
          </CanvasSection>
        )}
      </>
    );

    const footer = (
      <div className="cv-foot-actions">
        <button type="button" className="btn btn--primary btn--sm" onClick={() => navigate(openHref)}><span className="btn__label">Открыть отчёт</span><Icon name="arrow-up-right" size={14} /></button>
      </div>
    );
    return <CanvasViewForm {...header} onClose={onClose} openHref={openHref} openLabel="Открыть" footer={footer}>{body}</CanvasViewForm>;
  }

export { ABCCanvas };
